import { memo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import permissionModel from "./models/permisstion.model";
import { useNavigate } from "react-router-dom";
import ApiClient from "./methods/api/apiClient";
import { login_success } from "./Pages/actions/user";

const PageRoutes = ({ children, url = "", auth = false, Layout }) => {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const history = useNavigate();
  // let noUrlAccess=(!permissionModel.urlAllow(user))||false
  // if(auth&&!user.loggedIn) noUrlAccess=true
  // useEffect(()=>{
  //     if(user.loggedIn){
  //       if (noUrlAccess&&auth) {
  //         history("/profile?notAuthorized=true")
  //       }
  //     }else{
  //         if(auth){
  //             history("/login")
  //         }
  //     }
  //   },[user])

  useEffect(() => {
    if (user.loggedIn) {
      ApiClient.get("user/detail", { id: user._id || user.id }).then(
        async (res) => {
          if (res.success) {
            let data = { ...user, ...res.data };
            dispatch(login_success(data));
          }
        }
      );
    }
  }, []);

  // if(noUrlAccess){
  //     return <></>
  // }
  return (
    <>
      <div className="pageRoutes">
        {Layout ? (
          <>
            <Layout>{children}</Layout>
          </>
        ) : (
          <>{children}</>
        )}
      </div>
    </>
  );
};

export default memo(PageRoutes);
